var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{staticClass:"d-block",attrs:{"name":("social/" + _vm.name),"size":_vm.size,"fill":_vm.$scss.colors.primaryTextBg}})}
var staticRenderFns = []

export { render, staticRenderFns }